import * as Utils from './savanna_utils.js';

/* PERFORMANCE MANAGEMENT OBJ PLANS RULES */
export async function get_current_step_rules(performance_cycle_id, current_step, employee_id)
{
	let current_employee = Utils.current_employee_id();
	let user_role = '';

	// Determine if the current user is the employee or a manager
	if (current_employee === employee_id)
		user_role = 'employee';

	let manager_result = await Grape.fetches.getJSON('/api/record', {
		table: 'manager_employee',
		schema: 'public',
		filter: [{
			field: 'subordinate_employee_id',
			operand: '=',
			value: employee_id
		}]
	});

	if (manager_result.status != 'ERROR' && manager_result.records.some(record => record.employee_id === current_employee))
		user_role = 'manager';

	if (current_step)
	{
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'v_cycle_stages',
			schema: 'perfm_manage',
			filter_join: 'AND',
			filter: [{
				field: 'performance_cycle_id',
				operand: '=',
				value: performance_cycle_id
			},
			{
				field: 'step_sequence',
				operand: '=',
				value: current_step
			}]
		});
		

		if (res.status != 'ERROR' && res.result_count != 0)
		{
			let step = res.records[0];
			let current_rules = step.rules;

			let rules = {
				all_fields_everyone: false,
				all_fields_employee: false,
				all_fields_locked: false,
				name_description: true,
				outcomes_measures: true,
				feedback_manager: true,
				feedback_employee: true,
				peer_feedback: true,
				setup_peer_reviewer: true,
				add_objectives: true,
				edit_performance_cycle: true,
				linked_company_objectives: false
			};

			if (current_step > 1)
				rules.edit_performance_cycle = false;

			if (rules.all_fields_everyone === false)
				rules.all_fields_employee = false;

			current_rules.forEach(rule_obj => {
				let rule = rule_obj.rule;
				switch (rule)
				{
					case 'All fields editable by: Employee & Manager(s)':
						rules.all_fields_locked = false;
						break;
					case 'Objective fields locked':
						rules.name_description = false;
						rules.outcomes_measures = false;
						break;
					case 'Cannot add new/remove objectives':
						rules.add_objectives = false;
						break;
					case 'Objective fields locked (name & description)':
						rules.name_description = false;
						break;
					case 'Objective fields locked (outcomes & measures)':
						rules.outcomes_measures = false;
						break;
					case 'Feedback fields editable by: All':
						rules.feedback_manager = true;
						rules.feedback_employee = true;
						rules.peer_feedback = true;
						break;
					case 'Feedback fields editable by: Manager':
						rules.feedback_manager = true;
						break;
					case 'Feedback fields editable by: Employee':
						rules.feedback_employee = true;
						break;
					case 'Peer reviewer feedback fields editable':
						rules.peer_feedback = true;
						break;
					case 'Setup peer reviewer locked':
						rules.setup_peer_reviewer = false;
						break;
					case 'All data locked for employee':
						rules.all_fields_employee = false;
						break;
					case 'All data locked':
						rules.all_fields_locked = true;
						break;
					default:
						console.warn('Unknown rule:', rule);
				}
			});

			/*if (rules.all_fields_locked)
			{
				rules.all_fields_everyone = !rules.all_fields_locked;
				rules.all_fields_employee = !rules.all_fields_locked;
				rules.name_description = !rules.all_fields_locked;
				rules.outcomes_measures = !rules.all_fields_locked;
				rules.feedback_manager = !rules.all_fields_locked;
				rules.feedback_employee = !rules.all_fields_locked;
				rules.peer_feedback = !rules.all_fields_locked;
				rules.setup_peer_reviewer = !rules.all_fields_locked;
				rules.add_objectives = !rules.all_fields_locked;
				rules.edit_performance_cycle = !rules.all_fields_locked;
			}*/

			// Adjust rules based on user role
			if (user_role === 'employee')
			{
				if (!rules.all_fields_employee)
					rules.all_fields_locked = true;

				rules.feedback_manager = false;
				rules.peer_feedback = false;

			}
			else if (user_role === 'manager')
			{
				//rules.all_fields_employee = false;
				rules.feedback_employee = false;
				rules.peer_feedback = false;
				//rules.setup_peer_reviewer = false;
			}

			return rules;
		}
		else
			console.error('Error fetching records or no records found');
			return null;
	}
	else
	{
		let rules = {
			all_fields_everyone: false,
			all_fields_employee: false,
			all_fields_locked: false,
			name_description: true,
			outcomes_measures: true,
			feedback_manager: true,
			feedback_employee: true,
			peer_feedback: true,
			setup_peer_reviewer: true,
			add_objectives: false,
			edit_performance_cycle: true,
			linked_company_objectives: true
		};
		return rules;
	}
}

export async function get_steps_progress(performance_cycle_id, current_step, status)
{
	let all_steps;
	let res_steps = await Grape.fetches.getJSON('/api/record', {
		table: 'v_cycle_stages',
		schema: 'perfm_manage',
		filter_join: 'AND',
		filter: [{
			field: 'performance_cycle_id',
			operand: '=',
			value: performance_cycle_id
		}]
	});

	if (res_steps.status !== 'ERROR')
	{
		all_steps = res_steps.records;

		all_steps = all_steps.map(step => {
			if (step.step_sequence < current_step)
				return { ...step, status: 'Completed' };
			else if (step.step_sequence == current_step)
				return { ...step, status: status };
			else
				return { ...step, status: 'Not Started' };
		});

		all_steps.sort((a, b) => a.step_sequence - b.step_sequence);
	}
	else
		all_steps = [];

	return all_steps;
}